export const COG_OPTIONS = [
  { value: 'cold-caller', label: 'Cold Caller' },
  { value: 'short-change', label: 'Short Change' },
  { value: 'bottom-feeder', label: 'Bottom Feeder' },
  { value: 'flunky', label: 'Flunky' },
  { value: 'telemarketer', label: 'Telemarketer' },
  { value: 'penny-pincher', label: 'Penny Pincher' },
  { value: 'bloodsucker', label: 'Bloodsucker' },
  { value: 'pencil-pusher', label: 'Pencil Pusher' },
  { value: 'name-dropper', label: 'Name Dropper' },
  { value: 'tightwad', label: 'Tightwad' },
  { value: 'double-talker', label: 'Double Talker' },
  { value: 'yesman', label: 'Yesman' },
  { value: 'glad-hander', label: 'Glad Hander' },
  { value: 'bean-counter', label: 'Bean Counter' },
  { value: 'ambulance-chaser', label: 'Ambulance Chaser' },
  { value: 'micromanager', label: 'Micromanager' },
  { value: 'mover-and-shaker', label: 'Mover & Shaker' },
  { value: 'number-cruncher', label: 'Number Cruncher' },
  { value: 'back-stabber', label: 'Back Stabber' },
  { value: 'downsizer', label: 'Downsizer' },
  { value: 'two-face', label: 'Two-Face' },
  { value: 'money-bags', label: 'Money Bags' },
  { value: 'spin-doctor', label: 'Spin Doctor' },
  { value: 'head-hunter', label: 'Head Hunter' },
  { value: 'the-mingler', label: 'The Mingler' },
  { value: 'loan-shark', label: 'Loan Shark' },
  { value: 'legal-eagle', label: 'Legal Eagle' },
  { value: 'corporate-raider', label: 'Corporate Raider' },
  { value: 'mr-hollywood', label: 'Mr. Hollywood' },
  { value: 'robber-baron', label: 'Robber Baron' },
  { value: 'big-wig', label: 'Big Wig' },
  { value: 'the-big-cheese', label: 'The Big Cheese' },
];

export const COG_DEPARTMENTS = ['sellbot', 'cashbot', 'lawbot', 'bossbot'];

export const COG_KEY_OVERRIDES = {
  'mover-and-shaker': 'moverShaker',
};

export const COG_ACCURACY_OPTIONS = [
  { id: 'perfect', label: 'Perfect', chance: 100 },
  { id: 'max', label: 'Max', chance: 95 },
  { id: 'min', label: 'Min', chance: 5 },
  { id: 'ineffective', label: 'Ineffective', chance: 0 },
];

export const COG_USAGE_OPTIONS = [
  { id: 'weakest', label: 'Weakest possible' },
  { id: 'strongest', label: 'Strongest possible' },
  { id: 'strongest-single', label: 'Strongest single possible' },
  { id: 'random', label: 'Random' },
];

export const COG_TARGET_OPTIONS = [
  { id: 'strongest', label: 'Strongest toon' },
  { id: 'weakest', label: 'Weakest toon' },
  { id: 'random', label: 'Random' },
];

export const HP_BY_LEVEL = {
  1: 6,
  2: 12,
  3: 20,
  4: 30,
  5: 42,
  6: 56,
  7: 72,
  8: 90,
  9: 110,
  10: 132,
  11: 156,
  12: 196,
  13: 224,
  14: 254,
  15: 286,
};

export const DEFENSE_BY_LEVEL = {
  1: 2,
  2: 5,
  3: 10,
  4: 15,
  5: 20,
  6: 25,
  7: 30,
  8: 35,
  9: 40,
  10: 45,
  11: 50,
  12: 55,
  13: 60,
};
